import axios from "axios"
import NProgress from "nprogress"

const apiGlobal = axios.create({
  baseURL: "https://api.icap-maker.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
})

apiGlobal.interceptors.request.use(config => {
  NProgress.start()
  return config
})

apiGlobal.interceptors.response.use(response => {
  NProgress.done()
  return response
})

export default {
  Save(_saveOp) {
    return apiGlobal({
      method: "post",
      url: _saveOp.Url,
      data: _saveOp.Data
    })
      .then(function(response) {
        _saveOp.ObjectToSet[_saveOp.FieldToSet] =
          response.data[_saveOp.ReturnObject]
      })
      .catch(error => {
        alert(error)
      })
  },
  List(_url) {
    return apiGlobal({
      method: "get",
      url: _url
    })
  }
}
